import type { TotalNumberOfContractsListParams, TotalNumberOfContractsSortKey } from '../../types/pages'

export const DEFAULT_TYPES = ['CONTRACT_INVOICE', 'CONTRACT']

export const DEFAULT_PARAMS: TotalNumberOfContractsListParams = {
  page: 1,
  perPage: 15,
  sortBy: 'desc',
  orderBy: 'created_at',
  q: '',
  company_id: '',
  property_id: '',
  fromDt: '',
  toDt: '',
  contract_start_fromDt: '',
  contract_start_toDt: '',
  type: [...DEFAULT_TYPES],
  source: '',
  status: [],
  gateway_status: [],
  special_note: '',
}

export const SORT_COLUMNS: { key: TotalNumberOfContractsSortKey; label: string }[] = [
  { key: 'company_name', label: 'Company' },
  { key: 'property_name', label: 'Property' },
  { key: 'applicant_id', label: 'Applicant ID' },
  { key: 'application_id', label: 'Application ID' },
  { key: 'first_name', label: 'Name' },
  { key: 'payment_amount', label: 'Amount' },
  { key: 'purchase_date', label: 'Purchase Date' },
  { key: 'lease_start_date', label: 'Contract Start' },
]
